import {Directive, forwardRef} from '@angular/core';
import {
    AbstractControl,
    AsyncValidator,
    NG_ASYNC_VALIDATORS,
    ValidationErrors
} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {GenericValidator} from '../validacoes-form';

@Directive({
    selector: '[appCpfValidator]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => CpfValidatorDirective),
            multi: true
        }
    ]
})
export class CpfValidatorDirective implements AsyncValidator {

    validate(
        control: AbstractControl
    ): Observable<ValidationErrors | null> {
        const cpf = String(control.value ?? '').trim();

        if (!cpf) {
            return of(null);
        }

        return GenericValidator.validaCPF()(control);
    }
}
